import { ref, get } from "firebase/database";
import { database } from "../../../Utils/firebase";
import * as actionType from "../../../context/actions";
import GetAssignerUserBusinessData from "../AssignerUser/Business/GetAssignerUserBusinessDataInFirebase";

const GetBusinessDataFirebase = async (state, dispatch, fetchedAssigners = null) => {

  if (!state?.USERID) return null;

  try {

    const userRef = ref(
      database,
      `invoiceGenerator/users/${state.USERID}/company`
    );

    const snapshot = await get(userRef);
    const data = snapshot.val();
    let sortedData = [];

    if (data) {
      /* ---------------- USER OWN BUSINESSES ---------------- */
      const activeBusinesses = Object.entries(data).filter(
        ([, company]) => !company?.isDeleted
      );

      sortedData = activeBusinesses
        .map(([id, info]) => ({
          id,
          ...info,
          isShared: false
        }))
        .sort((a, b) => b.creationDate - a.creationDate)
        .map((item, index) => ({
          srNo: index + 1,
          ...item
        }));

      dispatch({
        type: actionType.BUSINESSES,
        payload: sortedData
      });
    } else {
      dispatch({
        type: actionType.BUSINESSES,
        payload: []
      });
    }

    /* ---------------- SHARED BUSINESSES ---------------- */

    const assignersToUse = fetchedAssigners || state?.ASSIGNERUSER || [];
    const agencyPlanName = process.env.REACT_APP_AGENCY_PLAN_NAME;

    // ✅ Only include owners who have an active Agency plan
    const agencyOwnerIds = [
      ...new Set(
        assignersToUse
          .filter((owner) => {
            const premium = owner?.premium;
            if (!premium) return false;

            // Check plan name from latest transaction
            const transactions = premium?.transactions
              ? Object.values(premium.transactions)
              : [];
            const latestTx = transactions.sort(
              (a, b) => (b.createdAt || 0) - (a.createdAt || 0)
            )[0];
            const ownerPlanName = latestTx?.planName?.trim();

            if (ownerPlanName !== agencyPlanName) return false;

            // Check if premium is still active (not expired)
            const premiumLastDate = premium?.premiumLastDate;
            if (!premiumLastDate) return false;

            const timestamp =
              premiumLastDate.toString().length > 10
                ? parseInt(premiumLastDate)
                : parseInt(premiumLastDate) * 1000;

            const today = new Date();
            today.setHours(0, 0, 0, 0);
            return new Date(timestamp).getTime() >= today.getTime();
          })
          .map((owner) => owner.ownerUid)
      )
    ];

    let sharedBusinesses = [];
    if (agencyOwnerIds.length) {
      sharedBusinesses = await GetAssignerUserBusinessData(
        { ...state, BUSINESSES: sortedData, ASSIGNERUSER: assignersToUse },
        dispatch,
        state.USERID,
        agencyOwnerIds
      );
    } else if (assignersToUse.length > 0) {
      // Owner exists but has no active Agency plan — clear shared businesses
      dispatch({
        type: actionType.ASSIGNERUSERBUSINESSES,
        payload: []
      });
    }

    return { ownBusinesses: sortedData, sharedBusinesses };

  } catch (error) {

    console.error("Error fetching company data:", error);
    return null;

  }
};

export default GetBusinessDataFirebase;